import { useLanguage } from '../lib/LanguageContext';
import { PrivacyPolicyEN } from './PrivacyPolicyEN';
import { PrivacyPolicyCS } from './PrivacyPolicyCS';
import { PrivacyPolicyDE } from './PrivacyPolicyDE';
import { PrivacyPolicyES } from './PrivacyPolicyES';
import { PrivacyPolicyFR } from './PrivacyPolicyFR';
import { PrivacyPolicyIT } from './PrivacyPolicyIT';
import { PrivacyPolicyPL } from './PrivacyPolicyPL';
import { PrivacyPolicyPT } from './PrivacyPolicyPT';
import { PrivacyPolicyNL } from './PrivacyPolicyNL';

export function PrivacyPolicy() {
  const { language } = useLanguage();

  switch (language) {
    case 'cs':
      return <PrivacyPolicyCS />;
    case 'de':
      return <PrivacyPolicyDE />;
    case 'es':
      return <PrivacyPolicyES />;
    case 'fr':
      return <PrivacyPolicyFR />;
    case 'it':
      return <PrivacyPolicyIT />;
    case 'pl':
      return <PrivacyPolicyPL />;
    case 'pt':
      return <PrivacyPolicyPT />;
    case 'nl':
      return <PrivacyPolicyNL />;
    default:
      return <PrivacyPolicyEN />;
  }
}
